// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__17bfz","addWidgetButton":"Header_addWidgetButton__l1Zwl","dashboardTabs":"Header_dashboardTabs__1K6U-","active":"Header_active__1v4ot"};